import { Component, Inject, OnInit } from '@angular/core';
import { IconRegistryService } from '../utilities/icon-registry.service';
import {UiService} from '../services/ui.service';
import { UserService } from '../services/user.service';
import { StaticDataService } from '../services/static-data.service';
import { MessagingService } from '../services/messaging.service';
import { MessagingConstants } from '../models/MessagingConstants';
import { Router } from '@angular/router';
import { Globals } from '../globals';
import { ToothService } from '../services/tooth.service';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit {
  public showLeftCol: boolean = true;
  public showMidCol: boolean = true;
  public showCompactCard: boolean = false;
  public showTopHalfOfCol: boolean = true;

  numScheduleItems: number = 0;
  numTaskItems: number = 0;
  numRecentPatients: number = 0;
  panelOpenState: boolean = false;
  isTopExpanded: boolean = true;

  public expansionState: string = 'col-lg-8';

  private updateState(): void {
    if (!this.showLeftCol && !this.showMidCol)
      this.expansionState = 'col-lg-12';
    else if (this.showLeftCol && this.showMidCol)
      this.expansionState = 'col-lg-8';
    else
      this.expansionState = 'col-lg-10';
  }

  constructor(
          iconRegistryService: IconRegistryService,
          public uiService: UiService,
          private staticDataService: StaticDataService,
          private messagingService: MessagingService,
          private router: Router,
          public globals: Globals,
          private toothService: ToothService,
          @Inject('Window') window: Window) {
    iconRegistryService.registerIcon('calendar', './assets/icons/icons8-calendar.svg');
    iconRegistryService.registerIcon('recent', './assets/icons/icons8-time-machine.svg');
    iconRegistryService.registerIcon('todo-list', './assets/icons/icons8-todo-list.svg');
    iconRegistryService.registerIcon('notes', './assets/icons/icons8-note.svg');
    iconRegistryService.registerIcon('description', './assets/icons/icons8-resume.svg');
    iconRegistryService.registerIcon('microscope', './assets/icons/icons8-microscope.svg');
    iconRegistryService.registerIcon('user', './assets/icons/icons8-customer.svg');
    iconRegistryService.registerIcon('eye', './assets/icons/icons8-eye.svg');
  }

  async ngOnInit() {
    window.name = "TDOProMainWindow";
    if (UserService.authToken  && !this.staticDataService.isReady) {

      await this.staticDataService.refreshValues();
      const promises: any[] = [
        this.toothService.getAllTeeth(ToothService.enumUnitedStatesToothGrouping).toPromise()
      ];
      try {
        const results: any[] = await Promise.all(promises);
        if (results[3]) {
          this.globals.teeth = results[0];
        }
      } catch (err) {
        console.log('Error retrieving notes.');
      }
    }

    this.messagingService.componentMessageCall.subscribe((response) => {
        const event = response.event;
        const eventData = response.data;

        switch (event) {
          case MessagingConstants.PATIENT_LOADED:
            this.globals.currentProviderDoctorID= null;
            this.globals.currentProviderDoctorFullName="";
            this.globals.currentProviderDoctorContactID=null;
            this.globals.currentProviderDoctorUserID=null;


            if (eventData.Process !== MessagingConstants.DO_NOT_LOAD_CASE_VIEW)
            {
              this.router.navigateByUrl('/landing/case-view');
            }
            break;
        }
      });
  }

  public handleSchedulingCardEvents(_event): void {
    this.showLeftCol = false;
    this.updateState();
  }

  public handlePatientInfoCardEvents(e): void {
    if (e === null || e === undefined) {
      this.showCompactCard = true;
      this.showMidCol = false;
    }
    else if (e.trim() === 'compact') {
      this.showCompactCard = false;
    }
    else if (e.trim() === 'expand') {
      this.showCompactCard = false;
      this.showMidCol = true;
    }

    this.updateState();
  }

  public handleCasesCardEvents(_event): void {
    this.showTopHalfOfCol = false;
  }

  public onLeftColBtn(): void {
    this.showLeftCol = true;
    this.updateState();
  }

  public onMidColBtn(): void {
    this.showMidCol = true;
    this.updateState();
  }
}
